export const messages = {
  labels: {
    startDate: {
      id: 'treatmentSummary.Groups.TransplantHistory.StartDate',
      defaultMessage: 'Date: ',
    },
    relatedDonor: {
      id: 'treatmentSummary.Groups.TransplantHistory.RelatedDonor',
      defaultMessage: 'Related Donor?: ',
    },
    providerName: {
      id: 'treatmentSummary.Groups.TransplantHistory.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.TransplantHistory.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.TransplantHistory.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.TransplantHistory.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.TransplantHistory.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
